export enum SidebarAction {
  Toggle,
  Close,
  Open
}

export type ContentType = 'docs' | 'api';

export type APIDomain = 'core' | 'ally';

export type APIDomainVersion = 'core_2.3' | 'core_3.0' | 'ally_2.3';